<template>
  <v-dialog
    v-model="dialog"
    max-width="90vh"
    scrollable
    :retain-focus="false"
    persistent
  >
    <SignaturePad
      :showSignaturePad="showSignaturePad"
      @close="showSignaturePad = false"
      @signatureData="signatureData"
    />

    <v-card height="100%">
      <v-toolbar color="primary" dark>{{ titleForm }}</v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-row class="mt-3">
          <v-col cols="12" md="6">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="month"
                  label="Month"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                ></v-text-field>
              </template>
              <v-date-picker
                type="month"
                v-model="date"
                :active-picker.sync="activePicker"
                @change="saveMonth"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="6">
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="newDate"
                  label="Day"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  :rules="rules"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="newDate"
                :active-picker.sync="activePicker1"
                :max="newMaxDate"
                :min="newMinDate"
                @change="validateDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row class="mt-1">
          <v-col cols="12" md="12">
            <v-text-field
              label="Amount"
              prefix="$"
              v-model="newAmount"
              outlined
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="mt-n8">
          <v-col cols="12" md="12">
            <v-checkbox
              label="Opened By"
              hide-details
              @change="addSignature($event)"
              v-model="checkedSignature"
            ></v-checkbox>
            <v-text-field v-model="newSignature"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <div class="ml-5" v-show="editMileage">
          <v-switch
            inset
            v-model="CloseOut"
            label="Closeout"
            @change="onUpdateStatus(CloseOut)"
          ></v-switch>
        </div>
        <v-spacer></v-spacer>

        <v-btn
          size="large"
          :disabled="disabled"
          class="white--text"
          :color="editMileage ? 'blue darken-1' : '#259647'"
          @click="editMileage ? onUpdateItem() : onAddItem()"
        >
          <div class="text-caption text-sm-body-1">
            {{ editMileage ? "Update" : "Save" }}
          </div>
        </v-btn>
        <v-btn color="blue darken-1" text @click="close">
          <div class="text-caption text-sm-body-1">
            Cancel
          </div>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/*eslint-disable */
import axios from "axios";
import SignaturePad from "@/components/SignaturePad";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
const url = require("../../client_config/config").url;

export default {
  props: ["mileageData"],
  components: {
    SignaturePad,
  },
  data() {
    return {
      activePicker: null,
      activePicker1: null,
      date: null,
      menu: false,
      menu1: false,
      month: null,
      day: null,
      newItem: false,
      newDate: "",
      newAction: "",
      newTransactionMethods: "",
      newAmount: "",
      newPayee: "",
      newExpenseCategory: "",
      newPurchaseLocation: "",
      newDepositCategory: "",
      newNotes: "",
      newSignature: "",
      newClientSignature: "",
      signaturepop2: false,
      newBalance: 0,
      newSigned: "",
      newReceipt: "",
      newReceiptImage: "",
      editMileage: false,
      newMileage: false,
      titleForm: "New Mileage Monthly Amount",
      action: ["Expense", "Deposit"],
      transactionMethods: ["Cash", "Debit Card", "EBT"],
      categories: [
        "Food",
        "Fast Food",
        "Personal Care",
        "Automotive",
        "Fuel",
        "Cigarettes",
        "Alcohol",
        "Entertainment",
        "Gifts",
        "Charity",
        "Bank Fee's",
        "Medical",
        "Dental",
        "Insurance",
        "Rent",
        "Utilities",
        "Phone",
        "Other",
      ],
      depositCategories: ["Benefits", "Wages", "Interests", "Other"],
      uploadImg: "",
      mileageID: "",
      staffID: localStorage.getItem("staffId"),
      staff: localStorage.getItem("Name"),
      msg: false,
      text: "",
      signed: false,
      showSignaturePad: false,
      checkedSignature: false,
      rules: [],
      dateParsed: "",
      minDate: "",
      maxDate: "",
      disabled: false,
      CloseOut: false,
      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      newMinDate: null,
      newMaxDate: null,
    };
  },

  computed: {
    ...mapGetters(["getMileageData"]),

    dialog: {
      get() {
        return this.$store.state.mileages.montlyAmountDialog;
      },
      set(val) {
        this.$store.commit("SET_MONTHLY_AMOUNT_DIALOG", val);
      },
    },
  },

  methods: {
    ...mapActions(["getMileages"]),

    saveMonth(date) {
      this.newMinDate = moment(new Date(date))
        .startOf("month")
        .format("YYYY-MM-DD");
      this.newMaxDate = moment(new Date(date))
        .endOf("month")
        .format("YYYY-MM-DD");

      const newDate = new Date(date);

      this.month = this.monthNames[newDate.getMonth()];

      this.newDate = moment(new Date(date))
        .startOf("month")
        .format("YYYY-MM-DD");

      this.$refs.menu.save(this.newDate);

      this.validateDate();
    },

    saveDay(date) {
      this.$refs.menu1.save(date);
    },

    onViewItem(item) {
      this.editMileage = true;
      this.mileageID = item._id;
      this.CloseOut = item.CloseOut;
      this.newDate = moment(new Date(item.Date)).format("YYYY-MM-DD");
      this.newAmount = item.Amount;
      this.newTransactionMethods = item.TransactionMethods;
      this.newNotes = item.Notes;
      this.newPayee = item.Payee;
      this.newSigned = item.Signed;
      this.newSignature = item.StaffSignature
        ? ((this.checkedSignature = true), item.StaffSignature)
        : ((this.checkedSignature = false), "");
      this.newReceipt = item.Receipt?.Name || "";
      if (item.Receipt !== "") {
        this.newReceiptImage = item.Receipt?.AWSLink || "";
      }

      this.minDate = moment(new Date(item.Date))
        .startOf("month")
        .format("YYYY-MM-DD");
      this.maxDate = moment(new Date(item.Date))
        .endOf("month")
        .format("YYYY-MM-DD");
    },

    validateDate() {
      if (this.editMileage) return (this.rules = []);

      const getMonth = (date) => {
        return new Date(date).getMonth() + 1;
      };

      const getYear = (date) => {
        return new Date(date).getFullYear();
      };

      let newMonth = getMonth(this.newDate);
      let newYear = getYear(this.newDate);

      const date = this.getMileageData.find((item) => {
        let itemMonth = getMonth(item.Date);
        let itemYear = getYear(item.Date);
        if (newMonth === itemMonth && newYear === itemYear) {
          return true;
        }
      });

      // this.rules = [date ? "Date already added for this month" : true];

      if (date) {
        this.rules = ["Date already added for this month"];
        this.disabled = true;
      } else {
        this.rules = [true];
        this.disabled = false;
      }
    },
    signatureData(data) {
      this.newClientSignature = data;
    },  
    async onAddItem() {
      var req_body = {
        Date: this.newDate,
        Month: this.month,
        Amount: this.newAmount,
        Balance: this.newAmount,
        StaffSignature: this.newSignature,
        StaffID: this.staffID,
      };

      this.$store.dispatch("addMileage", req_body).then((res) => {
        if (res.success) {
          this.mileageID = res.mileages._id;
          this.saveImg();
          this.$store.dispatch("addMileageTransaction", {
            ...req_body,
            MileageID: res.mileages._id,
          });
          this.$emit("getTransactions");
        }
      });

      this.close();
    },

    onUpdateItem() {
      var req_body = {
        Date: this.newDate,
        Amount: this.newAmount,
        Notes: this.newNotes,
        StaffSignature: this.newSignature,
        Signed: this.newSigned,
        StafftID: this.staffID,
      };

      this.$store
        .dispatch("updateMileage", { req_body, id: this.mileageID })
        .then((res) => {
          console.log("dispatch", res);
          this.saveImg();
          this.$emit("getTransactions");
        });

      this.close();
    },

    addSignature(e) {
      if (!e) return (this.newSignature = "");
      this.newSignature = this.staff + " - " + new Date();
      this.signed = true;
    },

    onUpdateStatus(e) {
      this.$store
        .dispatch("updateStatus", { CloseOut: e, id: this.mileageID })
        .then((res) => {
          console.log(res);
          this.$emit("getTransactions");
        });
      this.close();
    },

    close() {
      this.dialog = false;
      this.editMileage = false;
      this.disabled = false;
      this.rules = [];
      this.clear();
    },

    imgSelected(e) {
      this.uploadImg = e;
    },

    async saveImg() {
      if (
        this.uploadImg !== null &&
        this.uploadImg !== undefined &&
        this.uploadImg !== ""
      ) {
        const formData = new FormData();
        formData.append("receipt-img", this.uploadImg);
        var ct = { headers: { "content-type": "multipart/form-data" } };
        await axios
          .post(
            `${url}/mileages/imguploader/${this.mileageID}/${this.staffID}`,
            formData,
            ct
          )
          .then((res) => {
            if (res) {
              //this.getFinances();
              // this.getFinances(this.clientID);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    clear() {
      this.newDate = "";
      this.newAmount = "";
      this.newNotes = "";
      this.newSigned = "";
      this.newSignature = "";
      this.newReceipt = "";
      this.newReceiptImage = "";
      this.rules = [];
      this.minDate = "";
      this.maxDate = "";
      this.checkedSignature = false;
    },
  },
};
</script>
